import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SharedService } from '../../../shared/shared.service';
import { ScheduleService } from '../../schedule/schedule.service';
import { ToastsManager } from 'ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { UserService } from '../../user/user.service';
import { IList } from '../../../shared/component/list-filter/select.list.component';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

export interface Horarios {
  id: number;
  name: string;
  schedule_type_id: number | string;
}

@Component({
  selector: 'app-list-time',
  templateUrl: './list-time.component.html',
  styleUrls: ['./list-time.component.scss', '../../admin/admin.component.scss'],
  providers: [SharedService]
})
export class ListTimeComponent implements OnInit {


  @ViewChild('detailsModal')
  public detailsModal: ModalDirective;

  @ViewChild('deleteModal')
  public deleteModal: ModalDirective;

  @Input() modalRef: any;
  @Input() agent: any;
  @Input() schedules: any;

  @Output() refreshData = new EventEmitter<any>();

  public list: boolean;
  public scheduless: any;
  public day_helper: any[];
  public message_schdules_not_found: string;
  public id_schedule_delete;
  public _agregar: boolean;

  private _form: FormGroup;

  public _horarios: IList[] = [];

  //public load: boolean;

  constructor(private sharedService: SharedService,
    private scheduleService: ScheduleService,
    public toastr: ToastsManager,
    private logger: Logger,
    private _formBuilder: FormBuilder,
    private userService: UserService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    //console.log("Entro al componente list-time");
    this.mostrarList();
    this.day_helper = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

    this._form = this._formBuilder.group({
      horarioId: [null]
    });
    //console.log("Horarios entrantes", this.schedules);
    if (!this.schedules) {
      this.message_schdules_not_found = "No se encontraron horarios asignados a este agente.";
    }
  }

  private _getControl(key: string): FormControl {
    return <FormControl>this._form.controls[key] || null;
  }

  showDetailsModal(): void {
    this.modalRef.show();
  }

  hideDetailsModal(): void {
    this.mostrarList();
    this.modalRef.hide();
  }

  onDelete(id: string) {
    this.id_schedule_delete = id;
    this.deleteModal.show();
  }

  onDetails(id: number) {
    //this.load = true;
    this.spinner.show();
    let data = {
      auth_token: this.sharedService.getCookie('auth_token'),
      id: id
    };

    this.scheduleService.getSchedule(data).subscribe(
      data => {
        if (data.status) {
          this.scheduless = data.data;
        } else {
          this.message_schdules_not_found = "No se encontraron horarios asignados a este agente.";
          this.toastr.error(data.message, 'Error');
        }
        //this.load = false;
        this.spinner.hide();
        this.detailsModal.show();
      },
      error => {
        this.toastr.error('Ocurrio un error al consultar el detalle del horario!', ' Error');
        this.logger.log(error);
        //this.load = false;
        this.spinner.hide();
      }
    );
  }

  getDayByCode(id_week) {
    return this.day_helper[id_week - 1];
  }

  create() {
    this.list = false;
    this._agregar = false;
  }

  mostrarLista(schedule: any) {
    this.list = true;

    if (schedule != null) {

      let data = {
        auth_token: this.sharedService.getCookie('auth_token'),
        user_id: this.agent.id,
        schedule_ids: [schedule.id]
      }
      if (schedule.schedule_type_id == 2) {
        this.saveSchedulesUser(data);
        //this.refreshData.emit(schedule);
      } else {
        let param = {
          auth_token: this.sharedService.getCookie('auth_token'),
          id_agent: this.agent.id,
          type: 1
        }
        //evaluo si el susuario tiene horario regular asignado
        this.scheduleService.getSchedulesByIdAgentAndType(param).subscribe(
          resp => {
            if (resp.status && resp.data.length > 0) {
              this.toastr.info("No se pudo asociar el Horario al Agente", "Ya existe un horario regular asociado");
            } else {
              this.saveSchedulesUser(data);
            }
          }, error => {
            this.logger.error(error.message, 'Error');
          }
        );
      }
    }
  }

  agregar() {
    this.list = false;
    this._agregar = true;
    this._loadHorarios();
  }

  private _loadHorarios() {
    //this.load = true;
    this.spinner.show();
    let param = {
      auth_token: this.sharedService.getCookie('auth_token')
    }
    this.scheduleService.getList(param).subscribe(
      data => {
        if (data.status) {
          let idsAsignados = this.schedules != null ? this.schedules.map((selected) => { return selected.id }) : [];
          this._horarios = data.data.data.map((field: Horarios): IList => {
            return {
              id: field.id,
              text: field.name,
              select: idsAsignados.indexOf(field.id) !== -1,
              visible: true,
              type: field.schedule_type_id
            };
          });
        } else {
          this.toastr.error(data.message, 'Error');
        }
        //this.load = false;
        this.spinner.hide();
      },
      error => {
        //this.logger.log(error);
        //this.load = false;
        this.spinner.hide();
        this.toastr.error('Ocurrio un error al cargar los horarios!', ' Error');
      }

    );

  }


  onSubmit(event: Event) {
    if (event) {
      event.preventDefault();
    }

    let idsAsignados = this.schedules != null ? this.schedules.map((selected) => { return selected.id }) : [];
    //console.log("Asignados actualmente: ", idsAsignados);
    let seleccionados = this._form.get('horarioId').value;
    //console.log("Seleccionados: ", seleccionados);

    if (seleccionados) {

      let eliminar = idsAsignados != null ? idsAsignados.filter((param) => { return seleccionados.indexOf(param) == -1 }) : null;
      //console.log("debo eliminar: ", eliminar);

      let agregar = seleccionados.filter((param) => { return idsAsignados.indexOf(param) == -1 });
      //console.log("debo Agregar: ", agregar);
      if (eliminar && eliminar.length > 0) {
        let data = {
          auth_token: this.sharedService.getCookie('auth_token'),
          user_id: this.agent.id,
          schedule_ids: eliminar
        }
        this.deleteSchedulesUser(data);
      }

      if (agregar && agregar.length > 0) {
        let data = {
          auth_token: this.sharedService.getCookie('auth_token'),
          user_id: this.agent.id,
          schedule_ids: agregar
        }
        this.saveSchedulesUser(data);
      }
    } else {
      this._agregar = false;
      this.refreshData.emit(true);
    }

  }

  private saveSchedulesUser(data) {
    //this.load = true;
    this.spinner.show();
    if (data) {
      this.userService.saveUserSchedule(data).subscribe(
        res => {
          this.toastr.success('Horarios asociados con éxito.!');
          this.mostrarList();
          this.refreshData.emit(true);
          //this.load = false;
          this.spinner.hide();
        }, error => {
          //this.load = false;
          this.spinner.hide();
          this.toastr.error('Ocurrio un error al asociar los horarios!', ' Error');
          this.logger.error(error);
          this.refreshData.emit(true);
          this.mostrarList();
        }
      );
    }
  }

  private deleteSchedulesUser(data) {
    //this.load = true;
    this.spinner.show();
    if (data) {
      this.userService.deleteLoteUserSchedule(data).subscribe(
        res => {
          this.toastr.success('Horarios desasociados con éxito.!');
          this.mostrarList();
          this.refreshData.emit(true);
          //this.load = false;
          this.spinner.hide();
        }, error => {
          //this.load = false;
          this.spinner.hide();
          this.toastr.error('Ocurrio un error al intentar desasociar los horarios!', ' Error');
          this.mostrarList();
          this.refreshData.emit(true);
        }
      );
    }
  }

  deleteUserSchedule(id: string) {
    //this.load = true;
    this.spinner.show();
    //console.log("Id schedule user a eliminar", id);
    let data = {
      auth_token: this.sharedService.getCookie("auth_token"),
      id: id,
    }
    this.deleteModal.hide();
    this.userService.deleteUserSchedule(data).subscribe(
      data => {
        if (data.status) {
          //console.log("User Schedule eliminado correctamente", data);
          this.toastr.success('¡El horario ha sido desasociado correctamente! ');

        }
        //this.load = false;
        this.spinner.hide();
        this.refreshData.emit(true);
      },
      error => {
        //this.load = false;
        this.spinner.hide();
        this.toastr.success('¡Ocurrio un error al eliminar el horario! ', 'Error');
        //console.log("Ocurrio un error al eliminar el user schedule", error);
      }
    );
  }


  public mostrarList() {
    this._agregar = false;
    this.list = true;
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/emergency-times/list-time/list-time.component.ts